module.exports = __webpack_public_path__ + "img/og-procreate-5x_cn.0cc1a69.jpg";